module.exports = __webpack_public_path__ + "static/media/2000-01 (2).99a90bc3.jpg";